export const getNotificationUrl = (baseUrl: string) => ({
  // FCM 토큰 관리
  MANAGE_FCM_TOKEN: () => `${baseUrl}/notification/manage-fcm-token`,

  // 사용자 알림 조회
  GET_USER_NOTIFICATIONS: () => `${baseUrl}/notification/user-notifications`,

  // 알림 읽음 처리
  MARK_NOTIFICATION_AS_READ: () => `${baseUrl}/notification/mark-as-read`,

  // 알림 설정 업데이트
  UPDATE_NOTIFICATION_SETTINGS: () => `${baseUrl}/notification/settings`
})
